/**
 * Security Utilities for DOM XSS Prevention
 * Central utility functions for safe DOM manipulation
 * Version: 1.0.0
 *
 * Usage: Include this file before other scripts in your HTML:
 * <script src="/Scripts/SecurityUtils.js"></script>
 */

(function (window) {
    'use strict';

    // Prevent re-initialization
    if (window.SecurityUtils) {
        return;
    }

    var SecurityUtils = {};

    /**
     * Escape HTML special characters to prevent XSS
     * @param {string} str - The string to escape
     * @returns {string} - The escaped string safe for HTML insertion
     */
    SecurityUtils.escapeHtml = function (str) {
        if (str == null || str === undefined) {
            return '';
        }
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');

        //// Convert to string if not already
        //str = String(str);

        //var div = document.createElement('div');
        //div.textContent = str;
        //return div.innerHTML;
    };
    SecurityUtils.unescapeHtml = function (str) {
        if (str == null || str === undefined) {
            return '';
        }

        return String(str)
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&#39;/g, "'")
            .replace(/&#039;/g, "'")
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
            .replace(/&#10;/g, "\n")
            .replace(/&amp;/g, '&');
    };
    window.SecurityUtils = SecurityUtils;
})(window);